import type { commonTypes } from '@ltvco/refresh-lib/v1';

export const bestPhone = (
  phones: commonTypes.Phones | undefined
): commonTypes.Phone | undefined => {
  if (!phones?.length) {
    return undefined;
  }
  return phones.find((phone) => phone?.meta?.is_best) ?? phones[0];
};
